













































import { defineComponent, ref, computed } from '@vue/composition-api';
import Constants from '@/utils/Constants';
import SharedState from '@/data/SharedState';

export default defineComponent({
  name: 'VideoPreview',
  props: {
    videoId: {
      type: String,
      required: true
    },
    thumbnailUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: '',
    },
    duration: {
      type: Number,
      default: undefined
    },
    imgWidth: {
      type: Number,
      default: 0
    },
    imgHeight: {
      type: Number,
      default: 0
    },
    dateAddedMs: {
      type: Number,
      default: undefined
    },
    views: {
      type: Number,
      default: undefined
    },
    locale: {
      type: String,
      default: undefined
    },
    showDetailInfo: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'select-click': () => true
  },
  setup(props, context) {
    
    const previewElem = ref<HTMLDivElement|null>(null);

    const imgWidthC = computed((): string => {
      return props.imgWidth === 0
        ? '100%'
        : props.imgWidth + 'px';
    });
    const imgHeightC = computed((): string => {
      return props.imgHeight === 0
        ? '100%'
        : props.imgHeight + 'px';
    });

    const imageHeightAutoC = computed(() => {
      if(props.imgHeight !== 0) return imgHeightC.value;
      const grandParentWidth = previewElem.value?.parentElement?.parentElement?.clientWidth;
      if(!grandParentWidth) return imgHeightC.value;
      return grandParentWidth / Constants.videoDefaultAspectRatio + 'px';
    });


    const durationInMinutes = computed((): string => {

      const seconds = props.duration / 1000.0;
      const hours = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds - hours * 3600) / 60);
      const secs = Math.floor(seconds - (mins * 60 + hours * 3600)).toString().padStart(2, '0');
      return `${hours > 0 ? hours + ':' : ''}${hours > 0 ? mins.toString().padStart(2, '0') : mins}:${secs}`;
    });

    const viewsValue = computed(() => {
      return props.views + ' ' + SharedState.getText(context, 'corptube.views');;
    });
    const localDate = computed(() => {
      return new Date(props.dateAddedMs).toLocaleDateString(props.locale);
    });

    const detailInfoText = computed(() => {
      let text = '';
      if(props.views || props.views === 0) text += viewsValue.value;
      if(props.dateAddedMs)  {
        if(text) text += ' - '
        text += localDate.value;
      }
      return text;
    });

    return  {
      videoAspectRatio: Constants.videoDefaultAspectRatio,
      imgWidthC,
      imgHeightC,
      imageHeightAutoC,
      durationInMinutes,
      viewsValue,
      localDate,
      detailInfoText,
      previewElem
    };
  }
});
